window.LENORA_PRODUCTS = [
  {
    "handle": "wunscherfuller-hochzeit-tauben",
    "title": "Wunscherfüller Hochzeit — Taube",
    "motif": "Taube",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_123330_c0794e17-9a17-47ad-bcf0-67d8767d58d2.jpg?v=1774550866",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_123330_c0794e17-9a17-47ad-bcf0-67d8767d58d2.jpg?v=1774550866",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_123351_0faab244-4013-4fc6-a4dc-5459c0170de5.jpg?v=1774550893",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_124021_f487f657-d7d3-458d-b77b-7081a00254d5.png?v=1779625633",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_123807_f7b06122-3a13-4f62-9d11-05363c063115.jpg?v=1774550913"
    ],
    "description": "Tauben, die gemeinsam fliegen — wie zwei Menschen, die ihr Leben teilen.\nDieser Wunscherfüller mit klassischem Tauben-Motiv macht dein Geldgeschenk zur Hochzeit zu etwas Besonderem. Ausdrucken, Geldscheine aufkleben, verschenken. Zeitlos schön — und in 5 Minuten fertig.\nSo funkti",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-brautpaar",
    "title": "Wunscherfüller Hochzeit — Brautpaar",
    "motif": "Brautpaar",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_134622_834560fa-a69d-4f04-8d98-c422f2987dae.jpg?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_134622_834560fa-a69d-4f04-8d98-c422f2987dae.jpg?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_134813_fb88e963-d4b2-4c08-9d46-6c5e9ab1c082.jpg?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_135006_264f2342-ec9c-4be0-bdf8-37f195274790.jpg?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_134913_53459ef3-477c-4437-9dd8-6f38becd1068.jpg?v=1779625629"
    ],
    "description": "Sie gehen gemeinsam los — und du willst mehr geben als Geld im Umschlag.\nDieser Wunscherfüller zeigt das Brautpaar auf dem Weg in ihr neues Leben — elegant, romantisch, und mit Platz für dein Geldgeschenk. Ausdrucken, Geldscheine aufkleben, verschenken. So schön, dass das Brautpa",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-brautpaar-mit-herzen",
    "title": "Wunscherfüller Hochzeit — Brautpaar mit Herzen",
    "motif": "Brautpaar mit Herzen",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_134124_17983f10-b721-47d3-9c16-fd7e045d73fa.jpg?v=1774550486",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_134124_17983f10-b721-47d3-9c16-fd7e045d73fa.jpg?v=1774550486",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_133109_2b7fbb2c-2594-4fbf-b81a-aaf5e75db9cf.jpg?v=1774550558",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_132916_fc393b3b-ddcc-47b1-b77e-faa1d6b98fd8.jpg?v=1774550563",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_132601_d745214a-9611-48a1-bd98-3b1b76a32644.jpg?v=1774550566"
    ],
    "description": "Zwei Menschen, ein Ja — und du willst mehr geben als Geld im Umschlag.\nDieser Wunscherfüller zeigt das strahlende Brautpaar mit Herzballons — verspielt, romantisch, und mit Platz für dein Geldgeschenk. Ausdrucken, Geldscheine aufkleben, verschenken. So schön, dass das Brautpaar e",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-eheringe",
    "title": "Wunscherfüller Hochzeit — Eheringe",
    "motif": "Eheringe",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_173952_67638f6e-e1f8-4043-90f4-0e29c4985dbb.jpg?v=1774547073",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_173952_67638f6e-e1f8-4043-90f4-0e29c4985dbb.jpg?v=1774547073",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_174157_93e65873-008e-4867-bc09-f6796c34e1fb.jpg?v=1774547084",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_174234_59b27932-fc0e-496c-bc12-397a2bdbb80c.jpg?v=1774547121",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_174337_7a234cc8-d5bb-4e68-be4b-771da862945b.jpg?v=1774547172"
    ],
    "description": "Zwei Ringe, ein Versprechen, ein neues Kapitel.\n\nDu willst dem Brautpaar mehr geben als Geld im Umschlag — aber zum Basteln fehlt dir die Zeit (und vielleicht auch die Lust). Dieser Wunscherfüller macht dein Geldgeschenk in 5 Minuten zu etwas, das sich anfühlt wie mit Liebe vorbe",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-ring",
    "title": "Wunscherfüller Hochzeit — Ring",
    "motif": "Ring",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_111959_9cbb201a-da94-4ada-92f6-311e66b4dcf1.jpg?v=1774953010",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_111959_9cbb201a-da94-4ada-92f6-311e66b4dcf1.jpg?v=1774953010",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_112352_1b29acef-78b6-4eba-b190-7591afc5b67e.jpg?v=1774953027",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_112753_56e153a9-fe4d-401e-a7d7-26c3bbdd6d5b.jpg?v=1774953209",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_110626_ca3c6244-790c-4d38-ae17-8f8ee44ae891.jpg?v=1774953442"
    ],
    "description": "Das schönste Geldgeschenk auf dem Geschenketisch.\nAusdrucken. Herzen ausschneiden. Geldscheine einkleben. In den Bilderrahmen — fertig.\n93% aller Paare wünschen sich Geld. Aber nur du schenkst es so, dass sie es an die Wand hängen wollen. Kein Origami. Kein Wackelpudding. Kein Ba",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-kirchenfenster",
    "title": "Wunscherfüller Hochzeit — Kirchenfenster",
    "motif": "Kirchenfenster",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_105355_604447ae-dc9f-4a2d-80ec-57bf4fe10fa2.jpg?v=1774954827",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_105355_604447ae-dc9f-4a2d-80ec-57bf4fe10fa2.jpg?v=1774954827",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_105326_557f5eba-fbdf-454b-8f57-b93dfa1d404a.jpg?v=1774954897",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_154009_38ccea98-a57a-47f5-8f28-907774d005ab.jpg?v=1774954946",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_153528_be595dc0-2abc-49c3-9ebe-c588d9e92330.jpg?v=1774954963"
    ],
    "description": "Sie gehen gemeinsam durch die Tür. Du schenkst ihnen den Moment dahinter.\nDrei Kirchenfenster, drei Ausschnitte — drei Geldscheine, die das Brautpaar erst entdeckt wenn es genauer hinschaut. Kein Umschlag der aufgerissen wird. Ein Bild das enthüllt wird. Fenster für Fenster.\nUnd ",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-hochzeitstorte",
    "title": "Wunscherfüller Hochzeit — Hochzeitstorte",
    "motif": "Hochzeitstorte",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_160307_039de33b-779c-4035-837a-b6e009af1156.jpg?v=1774954159",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_160307_039de33b-779c-4035-837a-b6e009af1156.jpg?v=1774954159",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_160046_69666131-064a-40a4-aa58-d4def0dec052.jpg?v=1774954176",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_155618_5a76cf06-f8ac-4d1f-a53d-76f0f3eb5fd4.jpg?v=1774954250",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_155119_602926cb-29a5-4cbf-a726-bf21d048e5bc.jpg?v=1774954278"
    ],
    "description": "Das schönste Geldgeschenk auf dem Geschenketisch — und das einzige, das wie eine Torte aussieht.\nJede Etage der Torte ist ein Ausschnitt für einen Geldschein. Drei Freundinnen legen zusammen? Jede steckt einen Schein hinter \"ihre\" Etage. Ausdrucken, ausschneiden, einkleben, rahme",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-diamant",
    "title": "Wunscherfüller Hochzeit — Diamant",
    "motif": "Diamant",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_135923_2af7c961-1c02-487a-80bb-634c5f1a58a0.jpg?v=1779625631",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_135923_2af7c961-1c02-487a-80bb-634c5f1a58a0.jpg?v=1779625631",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_140222_10024c69-029c-444c-8a86-c4a912bf24b6.jpg?v=1779625632",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_143503_5882e592-5054-4dce-9a96-cc00ec94068b.jpg?v=1779625633"
    ],
    "description": "Manche Paare sind klassisch. Manche sind modern. Und manche verdienen einen Diamanten.\n\nWenn du ein Hochzeitsgeschenk suchst, das anders aussieht als die Standard-Herzen-und-Ringe — dann ist dieser Wunscherfüller genau richtig. Modern, elegant, mit einem Hauch Glamour. Perfekt fü",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-hochzeit-hochzeitsreise-kafer",
    "title": "Wunscherfüller Hochzeit — Flitterwochen",
    "motif": "Flitterwochen",
    "price": "4.90",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_115538_cb66e3c5-c4c0-42f8-8de2-ed2585684300.jpg?v=1774951334",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_115538_cb66e3c5-c4c0-42f8-8de2-ed2585684300.jpg?v=1774951334",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_122302_54ee4676-4d25-41c8-9e00-ae53f65f6cb1.jpg?v=1774951358",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_115032_53d6be07-0260-421a-a6d3-66c51af60b24.jpg?v=1774951438",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260326_115204_e7cb53ed-b6ae-4dac-af69-e816440cbcd9.jpg?v=1774951514"
    ],
    "description": "Die Koffer sind gepackt, das Auto geschmückt — und du willst mehr geben als Geld im Umschlag.\nDieser Wunscherfüller mit dem charmanten Hochzeitsauto macht dein Geldgeschenk zur Erinnerung. Für das Brautpaar, das gleich in die Flitterwochen startet — ausdrucken, Geldscheine aufkle",
    "categories": [
      "hochzeit"
    ],
    "builder_tags": [
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfuller-kommunion-kreuz",
    "title": "Wunscherfüller Kommunion — Kreuz",
    "motif": "Kreuz",
    "price": "4.90",
    "category": "kommunion",
    "category_label": "Kommunion",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_184325_de62626e-94c2-43c6-80c9-f6c59b0d5ce6.png?v=1775473964",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_184325_de62626e-94c2-43c6-80c9-f6c59b0d5ce6.png?v=1775473964",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_184408_5065b875-07f1-4e61-9ef0-df98e5dd2ea9.png?v=1775473964",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_184448_3c1ad4b8-e4a8-4c82-b7e0-19143f9eba72.png?v=1775473964"
    ],
    "description": "Alles Gute zur Kommunion — ein Wunscherfüller von Herzen\nDu bist eingeladen zur Erstkommunion. Dein Patenkind, die Tochter deiner Freundin, das Kind der Kollegin — und du weißt: Geld ist das Richtige. Die Eltern haben gesagt \"Bitte Geld, das Kind spart auf ein Fahrrad.\"\nAber du w",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "kommunion",
    "builder_tags": [
      "christlich",
      "kommunion"
    ]
  },
  {
    "handle": "wunscherfuller-kommunion-taube",
    "title": "Wunscherfüller Kommunion — Taube",
    "motif": "Taube",
    "price": "4.90",
    "category": "kommunion",
    "category_label": "Kommunion",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_185612_7f3a5c2c-289d-4019-b3ae-c1af83dab03c.png?v=1779625634",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_185612_7f3a5c2c-289d-4019-b3ae-c1af83dab03c.png?v=1779625634",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_185726_d4aa2ca2-9c17-4403-9991-d308a2744ce5.png?v=1779625632",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260405_185430_8a1410ed-19ac-41e6-9bf9-53cb1775ebe7.png?v=1779625631"
    ],
    "description": "Alles Gute zur Kommunion — Wir wünschen dir einen wundervollen Tag\nDie Erstkommunion steht an — und du bist als Patin, Tante oder Nachbarin eingeladen. Natürlich schenkst du Geld. Aber ein nackter Schein im weißen Umschlag? Nicht für so einen Tag.\nDieser Wunscherfüller verwandelt",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "kommunion",
    "builder_tags": [
      "christlich",
      "kommunion"
    ]
  },
  {
    "handle": "wunscherfuller-kommunion-fisch",
    "title": "Wunscherfüller Kommunion — Fisch",
    "motif": "Fisch",
    "price": "4.90",
    "category": "kommunion",
    "category_label": "Kommunion",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_085452_14b15d0d-0145-472c-82b6-16e764ced51f.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_085452_14b15d0d-0145-472c-82b6-16e764ced51f.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_085710_db468ca1-cca4-4d18-bdd3-b1cd803680ca.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_084635_3be95653-fb6a-48e3-9d52-3ddb6ab5b385.png?v=1779625632"
    ],
    "description": "Alles Gute zur Kommunion — Für einen ganz besonderen Tag\nDie Erstkommunion ist ein großer Moment — für das Kind und für alle, die dabei sind. Du willst etwas schenken, das mehr sagt als ein Umschlag.\nDieser Wunscherfüller macht dein Geldgeschenk zu etwas Persönlichem. Das Ichthys",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "kommunion",
    "builder_tags": [
      "christlich",
      "kommunion",
      "universal"
    ]
  },
  {
    "handle": "wunscherfuller-konfirmation-fisch",
    "title": "Wunscherfüller Konfirmation — Fisch",
    "motif": "Fisch",
    "price": "4.90",
    "category": "konfirmation",
    "category_label": "Konfirmation",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_094407_121188f4-dd23-4e30-9e1c-57a4ba413a34.png?v=1775469335",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_094407_121188f4-dd23-4e30-9e1c-57a4ba413a34.png?v=1775469335",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_091404_0f046f66-4728-47f5-977c-74e14015314d.png?v=1775469483",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_090555_dab2825a-40a8-4067-9a40-fff09df27b66.png?v=1775469509"
    ],
    "description": "Alles Gute zur Konfirmation — Für einen ganz besonderen Tag\nDer große Tag steht an. Dein Patenkind, deine Nichte, dein Enkel wird konfirmiert — und du willst mehr als einen Umschlag mit Geld.\nDieser Wunscherfüller verwandelt dein Geldgeschenk in etwas, das sich persönlich anfühlt",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "konfirmation",
    "builder_tags": [
      "christlich",
      "konfirmation",
      "universal"
    ]
  },
  {
    "handle": "wunscherfueller-konfirmation-kreuz",
    "title": "Wunscherfüller Konfirmation - Kreuz",
    "motif": "Kreuz",
    "price": "4.90",
    "category": "konfirmation",
    "category_label": "Konfirmation",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134036_060e8d76-f81b-47af-9c46-b1f6382b92df.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134036_060e8d76-f81b-47af-9c46-b1f6382b92df.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133927_8f818979-7b7d-4209-aa6d-5b498e9f3d27.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134107_984fb9a2-ad15-41a7-82e5-cc7f97e7e86e.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134134_b04b3d39-d461-4748-9780-dd75a592b275.png?v=1779625630"
    ],
    "description": "🎁 Wunscherfüller Konfirmation · Kreuz\nSamstag im Büro kommt die Nachricht von deiner Schwester: \"Du, in drei Wochen ist Konfirmation bei meinem Sohn.\" Oder dein Patenkind wird konfirmiert, der Nachbarsjunge, die Tochter der Kollegin — und du weißt, Geld ist das Richtige. Aber 100",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "konfirmation",
    "builder_tags": [
      "christlich",
      "konfirmation"
    ]
  },
  {
    "handle": "wunscherfueller-konfirmation-taube",
    "title": "Wunscherfüller Konfirmation - Taube",
    "motif": "Taube",
    "price": "4.90",
    "category": "konfirmation",
    "category_label": "Konfirmation",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134311_7bdec44f-7ea9-44a7-bbf4-01c9fe2cbe0e.png?v=1779625628",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134311_7bdec44f-7ea9-44a7-bbf4-01c9fe2cbe0e.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134529_d232ffd5-cc31-4a8c-98ec-146f7c7a622c.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134236_ac55d7f6-9674-4702-bd16-17c5bf3cb02e.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_134222_2e6cf8a7-61d0-4833-8420-19ca5399c85d.png?v=1779625629"
    ],
    "description": "🎁 Wunscherfüller Konfirmation · Taube\nDie Konfirmation deiner Patentochter ist in zwei Wochen, der Sohn deiner Schwester wird im Mai konfirmiert, das Patenkind deiner besten Freundin ist eingeladen — und du weißt: Geld ist genau das Richtige. 50, 100, vielleicht 150 Euro. Aber lo",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "konfirmation",
    "builder_tags": [
      "christlich",
      "konfirmation"
    ]
  },
  {
    "handle": "wunscherfuller-taufe-kreuz",
    "title": "Wunscherfüller Taufe — Kreuz",
    "motif": "Kreuz",
    "price": "4.90",
    "category": "taufe",
    "category_label": "Taufe",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_111234_2485b086-6948-47ed-99f3-fc39797c19ef.png?v=1779625631",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_111234_2485b086-6948-47ed-99f3-fc39797c19ef.png?v=1779625631",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_111632_cfc3e0cf-7aab-4832-ad64-79be0e0481fe.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_110849_cd2e73f5-9191-4a41-9e24-c4f7dfc74939.png?v=1779625630"
    ],
    "description": "Alles Gute zur Taufe! Ein Wunscherfüller von Herzen\n\nDeine beste Freundin hat dich zur Patentante gemacht. Das Baby wird getauft — und du willst etwas schenken, das mehr ist als ein Geldschein im Umschlag. Etwas, das die jungen Eltern sehen und denken: \"Sie hat sich wirklich Geda",
    "categories": [
      "christlich",
      "baby"
    ],
    "sub_anlass": "taufe",
    "builder_tags": [
      "christlich",
      "baby",
      "taufe"
    ]
  },
  {
    "handle": "wunscherfueller-firmung-kreuz",
    "title": "Wunscherfüller Firmung - Kreuz",
    "motif": "Kreuz",
    "price": "4.90",
    "category": "firmung",
    "category_label": "Firmung",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133225_6952ed73-2c91-4646-8873-a768dc721462.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133225_6952ed73-2c91-4646-8873-a768dc721462.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133334_8bf52060-f490-4d16-ae05-0fdcf6b9d5f8.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133352_3f058541-f6d5-4e3e-9c66-fd215bd72646.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133421_15815acf-2dbd-4337-bc51-c17b2219100a.png?v=1779625629"
    ],
    "description": "🎁 Wunscherfüller Firmung · Kreuz\nDeine Schwester ruft an: \"Du weißt schon, dass du Firmpatin bist? Die Firmung ist in drei Wochen.\" Oder dein Patenkind wird gefirmt, der Sohn der Kollegin, die Nichte aus dem anderen Bundesland. Geld ist klar, 50 bis 150 Euro. Aber als Firmpatin o",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "firmung",
    "builder_tags": [
      "christlich",
      "firmung"
    ]
  },
  {
    "handle": "wunscherfuller-firmung-fisch",
    "title": "Wunscherfüller Firmung — Fisch",
    "motif": "Fisch",
    "price": "4.90",
    "category": "firmung",
    "category_label": "Firmung",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_093148_52227726-bf0a-4363-9fa9-190387334507.png?v=1779625630",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_093148_52227726-bf0a-4363-9fa9-190387334507.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_091047_4786f817-71a1-4ff1-ab29-ef52b8266693.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_090246_f10358f1-522e-48f5-8467-3f50d8388b56.png?v=1779625630"
    ],
    "description": "Alles Gute zur Firmung — Für einen ganz besonderen Tag\nDie Firmung ist ein bewusster Schritt — dein Firmkind sagt Ja zum Glauben. Und du willst zeigen, dass dir dieser Moment genauso viel bedeutet.\nDieser Wunscherfüller macht dein Geldgeschenk persönlich. Das Ichthys-Symbol — der",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "firmung",
    "builder_tags": [
      "christlich",
      "firmung",
      "universal"
    ]
  },
  {
    "handle": "wunscherfueller-firmung-taube",
    "title": "Wunscherfüller Firmung - Taube",
    "motif": "Taube",
    "price": "4.90",
    "category": "firmung",
    "category_label": "Firmung",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133753_4b1b22fb-2c90-44c9-8976-557ce49b7af4.png?v=1779625628",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133753_4b1b22fb-2c90-44c9-8976-557ce49b7af4.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133854_c533e8e3-eb84-44bc-938b-8bbd6752310a.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133529_aab18942-2168-4f2d-90f7-dca8bd37f9f2.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260519_133508_d56f2faf-bc6e-46a3-8617-c6d44cd0a5c7.png?v=1779625629"
    ],
    "description": "🎁 Wunscherfüller Firmung · Taube\nDeine Schwester ruft an: \"Du weißt schon, dass du Firmpatin bist? Die Firmung ist in drei Wochen.\" Oder dein Patenkind wird gefirmt, der Sohn der Kollegin, die Nichte aus dem anderen Bundesland. Geld ist klar, 50 bis 150 Euro. Aber als Firmpatin o",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "firmung",
    "builder_tags": [
      "christlich",
      "firmung"
    ]
  },
  {
    "handle": "wunscherfueller-christlich-engel",
    "title": "Wunscherfüller Christlich - Engel",
    "motif": "Engel",
    "price": "4.90",
    "category": "christlich",
    "category_label": "Christlich",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_112745_3ec415a4-fd61-473a-ae3a-13b77a2fce40.png?v=1779625628",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_112745_3ec415a4-fd61-473a-ae3a-13b77a2fce40.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_112549_6a73eb90-9d2d-486e-a785-fa84b1a85745.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_112830_a24c2039-d6db-478e-ba41-1bc46312a361.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_112932_3298581f-5826-4ed7-9c36-29cf62409d63.png?v=1779625629"
    ],
    "description": "🎁 Wunscherfüller Christlich · Gesegnet und behütet · Engel\nIm Büro wird gesammelt für die Tauffeier vom Kind der Kollegin, deine Nachbarin lädt dich zur Kommunion ein, der Sohn der Schwägerin wird konfirmiert, das Patenkind deiner Cousine gefirmt. Vier verschiedene Feste in einem",
    "categories": [
      "christlich",
      "baby"
    ],
    "sub_anlass": "universal",
    "builder_tags": [
      "christlich",
      "baby",
      "universal"
    ]
  },
  {
    "handle": "wunscherfueller-christlich-kreuz",
    "title": "Wunscherfüller Christlich - Kreuz",
    "motif": "Kreuz",
    "price": "4.90",
    "category": "christlich",
    "category_label": "Christlich",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_124405_11d6c988-4620-4aab-9dc6-b1511e3cafd5.png?v=1779286112",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_124405_11d6c988-4620-4aab-9dc6-b1511e3cafd5.png?v=1779286112",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_114829_7b2d2c0f-9c9c-479d-bd36-6cfdcdb3993e.png?v=1779286138",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_113250_1c04b5d4-b41b-44a9-83dd-7b868fb4a3bd.png?v=1779286173",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_113125_a3337b38-7e90-4c2e-bc7e-6dd75d69897e.png?v=1779286173"
    ],
    "description": "🎁 Wunscherfüller Christlich · Gesegnet und behütet\nIm Büro wird gesammelt für die Tauffeier vom Kind der Kollegin, deine Nachbarin lädt dich zur Kommunion ein, der Sohn der Schwägerin wird konfirmiert, das Patenkind deiner Cousine gefirmt. Vier verschiedene Feste in einem Jahr, u",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "universal",
    "builder_tags": [
      "christlich",
      "universal"
    ]
  },
  {
    "handle": "wunscherfueller-christlich-schutzengel",
    "title": "Wunscherfüller Christlich - Schutzengel",
    "motif": "Schutzengel",
    "price": "4.90",
    "category": "christlich",
    "category_label": "Christlich",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_142835_2ac646ee-d40f-4465-a840-1c4b312279c6.png?v=1779625628",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_142835_2ac646ee-d40f-4465-a840-1c4b312279c6.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_143103_2cb01ad3-b292-4219-a33b-c299d267a000.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260520_143543_965c3e67-3b00-4c24-8f31-4d05556bcafa.png?v=1779625630"
    ],
    "description": "🎁 Wunscherfüller Christlich · Dein kleiner Schutzengel\nDeine beste Freundin bekommt ein Baby und du bist Patentante. Die Nichte wird getauft, der Sohn der Kollegin gefirmt, das Patenkind deiner Schwester konfirmiert. Manchmal willst du jemandem mehr mitgeben als Geld. Du willst s",
    "categories": [
      "christlich",
      "baby"
    ],
    "sub_anlass": "universal",
    "builder_tags": [
      "christlich",
      "baby",
      "universal"
    ]
  },
  {
    "handle": "wunscherfuller-christlich-kirche",
    "title": "Wunscherfüller Christlich — Kirche",
    "motif": "Kirche",
    "price": "4.90",
    "category": "christlich",
    "category_label": "Christlich",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_083532_565747d1-6102-481c-a686-a43c4bb94811.png?v=1775473086",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_083532_565747d1-6102-481c-a686-a43c4bb94811.png?v=1775473086",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_083951_ec661986-b1a4-4664-a2fa-9668cb1297ff.png?v=1775473129",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_082916_96dfa21a-e256-4590-9d93-de9423928fcd.png?v=1775473092"
    ],
    "description": "Gesegnet und behütet — ein Wunscherfüller von Herzen\nSonntagmorgen, die Glocken läuten, dein Patenkind steht vorne am Altar. Egal ob Taufe, Kommunion, Konfirmation oder Firmung — dieser Moment verdient mehr als einen Umschlag.\nDieser Wunscherfüller zeigt eine liebevoll gemalte Ki",
    "categories": [
      "christlich"
    ],
    "sub_anlass": "universal",
    "builder_tags": [
      "christlich",
      "universal"
    ]
  },
  {
    "handle": "wunscherfuller-du-hast-dir-nichts-gewunscht",
    "title": "Wunscherfüller \"Du hast dir nichts gewünscht\"",
    "motif": "Wunscherfüller \"Du hast dir nichts gewünscht\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_104142_b9e8fdd8-9e73-4e50-afbd-6c54cd483895.png?v=1779625630",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_104142_b9e8fdd8-9e73-4e50-afbd-6c54cd483895.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_103646_81aec3d9-0569-4a2f-9327-52b2a67a232d.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_103325_aa849242-88de-467a-b268-ffc23821d382.png?v=1779625630"
    ],
    "description": "\"Ich wünsch mir nichts.\" Kennst du. Jetzt kriegt sie's auch.\nSie sagt seit Wochen, sie wünscht sich nichts. Du glaubst ihr nicht ganz. Du willst ihr etwas geben, aber nicht das nächste Duftkerzen-Set, das in der Schublade landet. Geld lose im Umschlag wirkt für so einen Moment na",
    "categories": [
      "lustig",
      "geburtstag",
      "meilensteine"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag",
      "meilensteine"
    ]
  },
  {
    "handle": "wunscherfuller-ein-paar-kroten-fur-dich",
    "title": "Wunscherfüller \"Ein paar Kröten für dich\"",
    "motif": "Wunscherfüller \"Ein paar Kröten für dich\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_100944_407e0b27-0360-43eb-bba3-bcf1424e7fed.png?v=1779625636",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_100944_407e0b27-0360-43eb-bba3-bcf1424e7fed.png?v=1779625636",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_100859_df14f903-1d04-4a8c-a4b6-185fdeca4c0e.png?v=1779625634",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_100720_bbe0149e-6c18-4cdf-8e75-326ddc477d14.png?v=1779625631"
    ],
    "description": "🎁 Wunscherfüller Geburtstag · Ein paar Kröten für dich\nDein Mann wird 40, der Schwiegervater 70, dein Bruder zieht in die erste eigene Wohnung, deine Kollegin geht in Rente. Vier verschiedene Männer, ein Anlass: alle sagen \"brauch nix\" und meinen es ernst. Geld ist die ehrliche A",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag"
    ]
  },
  {
    "handle": "wunscherfueller-ein-bisschen-kohle-fuer-dich",
    "title": "Wunscherfüller \"Ein bisschen Kohle für dich\"",
    "motif": "Wunscherfüller \"Ein bisschen Kohle für dich\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_141232_49497b54-cc67-4e9b-945c-87047bc9045f.png?v=1779891423",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_141232_49497b54-cc67-4e9b-945c-87047bc9045f.png?v=1779891423",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_141244_4532a7f4-c77b-4beb-836f-4199946ff5ee.png?v=1779891445",
      "https://d2ol7oe51mr4n9.cloudfront.net/user_38bs0pFfyPuW7nmZBGdir5RRXgo/cc7f931b-259d-419b-bef0-693afddd0247.png"
    ],
    "description": "🎁 Wunscherfüller Wortwitz · Ein bisschen Kohle für dich\nDein Mann wird 40, der Nachbar feiert runden Geburtstag im Garten, der Schwager bekommt zum 50. endlich den neuen Kugelgrill. Drei Typen, ein Anlass: alle haben einen Grill, alle sagen \"brauch nix\" und alle würden sich ein b",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag"
    ]
  },
  {
    "handle": "wunscherfuller-hier-hast-du-dein-nix",
    "title": "Wunscherfüller \"Hier hast du dein Nix\"",
    "motif": "Wunscherfüller \"Hier hast du dein Nix\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_102417_55754028-fd97-4f5c-89fa-c2daf027330e.png?v=1779625631",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_102417_55754028-fd97-4f5c-89fa-c2daf027330e.png?v=1779625631",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_102522_b069bd97-8e0f-42cc-a9d1-f5ac8fafc90b.png?v=1779625633",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_102031_709b25fd-862f-4358-ae10-ddb672aab52d.png?v=1779625630"
    ],
    "description": "🎁 Wunscherfüller Geburtstag · Hier hast du dein Nix\nDein Bruder wird 40, der Schwiegervater 70, der Mann deiner besten Freundin runder Geburtstag. Du fragst was er sich wünscht und kriegst zur Antwort: \"Nix, ich brauch nix.\" Geld ist die ehrliche Antwort, 50 bis 150 Euro. Aber lo",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag",
      "runder-geburtstag"
    ]
  },
  {
    "handle": "wunscherfuller-hier-sind-ein-paar-mause",
    "title": "Wunscherfüller \"Hier sind ein paar Mäuse\" (Motiv 2)",
    "motif": "Wunscherfüller \"Hier sind ein paar Mäuse\" (Motiv 2)",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260414_173016_d247c063-c139-4df9-ab25-7757d8fdeb89.png?v=1779625630",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260414_173016_d247c063-c139-4df9-ab25-7757d8fdeb89.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_105806_df99f6eb-1d72-410c-bb46-a1f92918be82.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_105649_bf46d1dc-c819-452b-930a-4665797021f5.png?v=1779625631"
    ],
    "description": "🎁 Wunscherfüller Geburtstag · Hier sind ein paar Mäuse (Motiv 2)\nDeine Freundin wird 35, die Schwester 30, die Patentochter 18, die Kollegin verlässt das Büro. Alle haben \"ach, schenk doch einfach was\" gesagt und du weißt: Geld ist die ehrliche Antwort, 30 bis 100 Euro. Aber lose",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag"
    ]
  },
  {
    "handle": "wunscherfuller-hier-sind-ein-paar-mause-motiv-2",
    "title": "Wunscherfüller \"Hier sind ein paar Mäuse\" (Motiv 1)",
    "motif": "Wunscherfüller \"Hier sind ein paar Mäuse\" (Motiv 1)",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260414_173858_d9cbd1a0-f5c1-46ee-8977-b43143043a59.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260414_173858_d9cbd1a0-f5c1-46ee-8977-b43143043a59.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_105017_dca401a7-c866-4011-a70b-0316c0d8401b.png?v=1779625632",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260419_104817_73016e08-a965-4bc6-aba6-bb618ddf8ebb.png?v=1779625633"
    ],
    "description": "🎁 Wunscherfüller Geburtstag · Hier sind ein paar Mäuse (Motiv 1)\nDeine Freundin wird 35, die Schwester 30, die Patentochter 18, die Kollegin verlässt das Büro. Alle haben \"ach, schenk doch einfach was\" gesagt und du weißt: Geld ist die ehrliche Antwort, 30 bis 100 Euro. Aber lose",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag"
    ]
  },
  {
    "handle": "wunscherfuller-weil-du-etwas-ganz-besonderes-bist",
    "title": "Wunscherfüller \"Weil du etwas ganz Besonderes bist\"",
    "motif": "Wunscherfüller \"Weil du etwas ganz Besonderes bist\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_114005_248c37b2-2295-43f7-8441-3f29c3fd0557.png?v=1779625631",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_114005_248c37b2-2295-43f7-8441-3f29c3fd0557.png?v=1779625631",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_113256_753ff6a4-a7dc-4967-bf83-d06b30f2ec7c.png?v=1775475411",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260325_084209_b756fe97-b533-4c60-8637-6912fa0f65a8.jpg?v=1775475475",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_114128_9a5b460b-7421-4711-a1c1-8e951e4f6c7a.png?v=1775476018"
    ],
    "description": "Von Herzen — Weil du etwas ganz Besonderes bist\nSabine geht. Nach 8 Jahren im Büro, immer da, immer zuverlässig. Ihr habt gesammelt — 120 Euro liegen im Umschlag. Aber ein weißer Umschlag für jemanden der dir 8 Jahre lang den Rücken freigehalten hat? Das geht besser.\nDieser Wunsc",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag",
      "geschafft"
    ]
  },
  {
    "handle": "wunscherfueller-fuer-meinen-schatz",
    "title": "Wunscherfüller \"Für meinen Schatz\"",
    "motif": "Wunscherfüller \"Für meinen Schatz\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_080746_084fd03e-549d-4194-a0be-a3ddc9b61c7c.png?v=1779963855",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_080746_084fd03e-549d-4194-a0be-a3ddc9b61c7c.png?v=1779963855",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_080543_a347403e-c43a-4a5f-a93d-e2d69f7243ee.png?v=1779964001",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_080301_70f03ac7-ff32-4fc1-a67d-c28157b82804.png?v=1779963963",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_080424_001704a8-1080-48b2-a3ac-b89bb1281aea.png?v=1779963934"
    ],
    "description": "🎁 Wunscherfüller · Für meinen Schatz\nEuer erster Jahrestag steht an, sein 40. Geburtstag kommt im Sommer, oder ihr feiert den Hochzeitstag und du willst mehr schenken als die Karte aus dem Drogeriemarkt. Geld klingt im ersten Moment nach \"fällt mir nichts ein\", aber zwischen euch",
    "categories": [
      "lustig",
      "geburtstag"
    ],
    "builder_tags": [
      "lustig",
      "geburtstag"
    ]
  },
  {
    "handle": "wunscherfueller-frisch-gewaschen",
    "title": "Wunscherfüller \"Frisch Gewaschen\"",
    "motif": "Wunscherfüller \"Frisch Gewaschen\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_140028_59bde1c3-df8c-42ff-8a49-2b5be6c412b6.png?v=1779890747",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_140028_59bde1c3-df8c-42ff-8a49-2b5be6c412b6.png?v=1779890747",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_135735_4a0492ca-868b-496f-9bb0-03249d39cf83.png?v=1779890757",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_135025_e1d3700f-c146-45d5-98e4-7463f9c3340d.png?v=1779890769"
    ],
    "description": "🎁 Wunscherfüller Geburtstag · Frisch gewaschen\nDein Schwager wird 50, der Onkel feiert Ruhestand, der Kumpel von deinem Mann zieht in die neue Wohnung. Alle haben \"ach, brauch nichts\" gesagt und du weißt: Geld ist die ehrliche Antwort, 30 bis 100 Euro. Aber lose im Umschlag wirkt",
    "categories": [
      "lustig",
      "meilensteine"
    ],
    "builder_tags": [
      "lustig",
      "meilensteine",
      "ruhestand"
    ]
  },
  {
    "handle": "wunscherfueller-trinkgeld-fuer-dich",
    "title": "Wunscherfüller \"Trinkgeld für dich\"",
    "motif": "Wunscherfüller \"Trinkgeld für dich\"",
    "price": "4.90",
    "category": "lustig",
    "category_label": "Lustig & Frech",
    "is_bundle": false,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_073913_cf30c28f-b88e-43d6-85e0-77c41ee45f10.png?v=1779954519",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_073913_cf30c28f-b88e-43d6-85e0-77c41ee45f10.png?v=1779954519",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260528_074330_d427b3f6-900f-4caa-9efc-7c38f63ee046.png?v=1779954605",
      "https://d2ol7oe51mr4n9.cloudfront.net/user_38bs0pFfyPuW7nmZBGdir5RRXgo/46b4a94d-0780-4f7d-a7fe-366ff9668b97.png"
    ],
    "description": "🎁 Wunscherfüller Wortwitz · Trinkgeld für dich\nDeine beste Freundin wird 35, die Kollegin verlässt das Büro auf eine längere Auszeit, deine Schwester feiert ihren 40er mit Mädelsabend. Drei Frauen, ein Anlass: alle lieben einen guten Cocktail, alle hätten sich \"ach, geh halt mal ",
    "categories": [
      "lustig",
      "meilensteine"
    ],
    "builder_tags": [
      "lustig",
      "meilensteine"
    ]
  },
  {
    "handle": "wunscherfuller-von-herzen-3er-bundle-universal-besonders-dankeschon-personlich",
    "title": "Wunscherfüller Von Herzen · 3er Bundle Universal (Besonders, Dankeschön & Persönlich)",
    "motif": "Wunscherfüller Von Herzen · 3er Bundle Universal (Besonders, Dankeschön & Persönlich)",
    "price": "9.80",
    "category": "danke",
    "category_label": "Danke",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_135615_43983e75-f480-4bc6-8b23-68b2daae9023.png?v=1779625630",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_135615_43983e75-f480-4bc6-8b23-68b2daae9023.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_114327_3cb2aea5-cb4e-4170-a933-b53397f998cb.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_113723_2e604359-d7fc-484d-8609-6cb9621f8dcc.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260406_114005_248c37b2-2295-43f7-8441-3f29c3fd0557.png?v=1779625631"
    ],
    "description": "🎁 Universal-Komplettset: 3 Designs zum Preis von 2! (9,80 € statt 14,70 €)\nManchmal weißt du genau, dass du etwas schenken willst, aber der Anlass passt in keine Schublade. Die Erzieherin geht nach acht Jahren in Rente. Die Nachbarin hat dir zum dritten Mal das Paket angenommen. ",
    "categories": [
      "bundles",
      "meilensteine",
      "geburtstag"
    ],
    "builder_tags": [
      "bundles",
      "meilensteine",
      "geburtstag",
      "universal"
    ]
  },
  {
    "handle": "wunscherfuller-set-baby-erster-geburtstag-3er-bundle-teddybar-1-2-3-ballons-zum-ausdrucken",
    "title": "Wunscherfüller-Set Baby & erster Geburtstag — 3er Bundle Teddybär (1, 2 & 3 Ballons)",
    "motif": "3er Bundle Teddybär (1, 2 & 3 Ballons)",
    "price": "9.80",
    "category": "geburt",
    "category_label": "Geburt & Baby",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_112339_2168c722-6ef6-481d-bfb3-963d87dcb844.png?v=1777970633",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_112339_2168c722-6ef6-481d-bfb3-963d87dcb844.png?v=1777970633",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_093804_9fd913a9-f759-44d8-909f-4833c4ad8de0.png?v=1777970738",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_094013_2e456d28-d379-4218-aee7-520b9950baaf.png?v=1777970693",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_094357_2a64a775-316e-4dff-829f-0b12ebd0c00a.png?v=1777970727"
    ],
    "description": "🎁 Geburtstags-Komplettset für Kinder: 3 Designs zum Preis von 2! (9,80 € statt 14,70 €)Ein Patenkind hat Geburtstag, die kleine Nichte wird sechs, oder das Enkelkind freut sich auf seinen großen Tag. Geld lose im Umschlag wirkt für ein Kind nach nichts. Eine Karte vom Drogeriemar",
    "categories": [
      "bundles",
      "baby",
      "geburtstag"
    ],
    "builder_tags": [
      "bundles",
      "baby",
      "geburtstag",
      "erster-geburtstag"
    ]
  },
  {
    "handle": "wunscherfuller-set-bestanden",
    "title": "Wunscherfüller-Set \"Bestanden!\" Stolz auf dich · 3er Bundle (für Prüfung, Führerschein, Abschluss)",
    "motif": "Set \"Bestanden!\" Stolz auf dich · 3er Bundle (für Prüfung, Führerschein, Abschluss)",
    "price": "9.80",
    "category": "bestanden",
    "category_label": "Pruefung & Abschluss",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260511_091834_a0ddc0c6-3857-48f8-845c-4d1d5857521a.png?v=1778494218",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260511_091834_a0ddc0c6-3857-48f8-845c-4d1d5857521a.png?v=1778494218",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260511_091817_68c903c3-62f0-4088-89d8-820c7ca7e2c9.png?v=1778494227",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_092544_bb26442c-8c38-4fa5-9328-48141e79c2a6.png?v=1778494374",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260503_092859_ec3f960a-20e8-41b3-98a5-d0f56b5ed047.png?v=1778494317"
    ],
    "description": "🎁 Bestanden-Komplettset: 3 Designs zum Preis von 2! (9,80 € statt 14,70 €)\nDas Patenkind hat das Abi geschafft. Die Tochter der Freundin hat den Führerschein. Im Büro hat die Auszubildende die IHK-Prüfung bestanden. Geld lose im Umschlag wirkt nach Pflichtübung. Mit diesem Bundle",
    "categories": [
      "bundles",
      "meilensteine"
    ],
    "builder_tags": [
      "bundles",
      "meilensteine",
      "bestanden",
      "geschafft",
      "fuehrerschein"
    ]
  },
  {
    "handle": "wunscherfuller-set-danke-5er-bundle",
    "title": "Wunscherfüller-Set \"Danke\" - 5er Bundle",
    "motif": "5er Bundle",
    "price": "14.70",
    "category": "danke",
    "category_label": "Danke",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260506_115407_92104c97-5ac6-49bb-8263-1f8b2a74cbd7.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260506_115407_92104c97-5ac6-49bb-8263-1f8b2a74cbd7.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260506_110447_c6b3de62-8859-42a3-a2db-ed3f27509e43.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260511_091436_8973b242-3322-476c-b06f-6e4db15d7d43.png?v=1779625633",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260511_092229_3d4ebca2-bb95-4625-a994-a1b46ecac083.png?v=1779625629"
    ],
    "description": "🎁 Danke-Komplettset: 5 Designs zum Preis von 3! (14,70 € statt 24,50 €)\nDie Kollegin geht nach 25 Jahren in Rente. Die Schwiegermutter holt seit zwei Jahren die Kinder vom Hort. Die Trauzeugin hat die ganze Hochzeit geschmissen. Im Büro wird Sabine zum Abschied verabschiedet. Die",
    "categories": [
      "bundles",
      "meilensteine"
    ],
    "builder_tags": [
      "bundles",
      "meilensteine",
      "abschied",
      "geschafft"
    ]
  },
  {
    "handle": "wunscherfuller-set-die-klassiker-3er-bundle-abschied-abenteuer-runder-geburtstag",
    "title": "Wunscherfüller-Set \"Die Klassiker\" - 3er Bundle (humorvoller Abschied, Abenteuer, Runder Geburtstag)",
    "motif": "3er Bundle (humorvoller Abschied, Abenteuer, Runder Geburtstag)",
    "price": "9.80",
    "category": "geburt",
    "category_label": "Geburt & Baby",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_133356_918ad1ab-2e8e-4d2e-8bc0-fe6c733a7b68.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_133356_918ad1ab-2e8e-4d2e-8bc0-fe6c733a7b68.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_112205_578dc4e0-548c-4d19-b321-713c1c1de9bf.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_112559_5cc0127b-83c7-4107-8931-0b83ba99df79.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_111757_f50105a2-2488-475b-a53e-9d766ee02777.png?v=1779625628"
    ],
    "description": "🎁 3er Bundle für die großen Übergänge: 3 Designs zum Preis von 2!(9,80 € statt 14,70 €)\nEs passiert immer dann, wenn du es am wenigsten erwartest. Eine Kollegin kündigt, das Patenkind zieht ins Ausland, die Schwester wird vierzig. Drei Wochen, drei Geschenke, drei Anlässe, bei de",
    "categories": [
      "bundles",
      "meilensteine",
      "geburtstag",
      "baby"
    ],
    "builder_tags": [
      "bundles",
      "meilensteine",
      "geburtstag",
      "baby",
      "runder-geburtstag",
      "abschied"
    ]
  },
  {
    "handle": "wunscherfuller-set-geburt-3er-bundle-baby-babyschuhe-storch-mobile",
    "title": "Wunscherfüller-Set Geburt & Mutterschutz · 3er Bundle Baby (Babyschuhe · Storch · Mobile)",
    "motif": "Set Geburt & Mutterschutz · 3er Bundle Baby (Babyschuhe · Storch · Mobile)",
    "price": "9.80",
    "category": "geburt",
    "category_label": "Geburt & Baby",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_134721_9c1155bd-bec5-42ab-b743-07dac030c0c6.png?v=1779625630",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_134721_9c1155bd-bec5-42ab-b743-07dac030c0c6.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_111439_27d045de-425a-4e3e-a1a1-9f31c6480f1b.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_111106_95237e54-b3f1-43d7-9f7a-e411c8d17bb6.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_104125_16ce2999-de5a-483e-9e3a-049302aaaca5.png?v=1779625629"
    ],
    "description": "🎁 Baby-Komplettset: 3 Designs zum Preis von 2! (9,80 € statt 14,70 €)\nEine Freundin bekommt ein Baby. Die Schwester ist im neunten Monat. Im Büro wird zur Pullerparty eingeladen. Geld lose im Umschlag wirkt für so einen Wunder-Moment nach nichts. Eine Karte vom Drogeriemarkt vers",
    "categories": [
      "bundles",
      "baby"
    ],
    "builder_tags": [
      "bundles",
      "baby"
    ]
  },
  {
    "handle": "wunscherfuller-set-geschafft-3er-bundle-stolz-auf-dich-fur-abi-fuhrerschein-abschluss-all-deine-verdienste-die-anerkennung-verdienen",
    "title": "Wunscherfüller-Set \"Geschafft!\" · 3er Bundle (für all die Verdienste die Anerkennung verdienen)",
    "motif": "Set \"Geschafft!\" · 3er Bundle (für all die Verdienste die Anerkennung verdienen)",
    "price": "9.80",
    "category": "bestanden",
    "category_label": "Pruefung & Abschluss",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_132805_4ea60330-814e-44af-8712-8aef447cf561.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_132805_4ea60330-814e-44af-8712-8aef447cf561.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_132622_0f3c2ef5-f801-402e-a1d0-bc3bfa03f73a.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_122105_f2918611-7dd3-4256-a51b-47b715b1fc35.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_122531_2c78bdb7-8bea-4577-aac2-a59301320d18.png?v=1779625628"
    ],
    "description": "🎁 Geschafft-Komplettset: 3 Designs zum Preis von 2! (9,80 € statt 14,70 €)\nDas Patenkind hat das Abitur in der Tasche. Der Neffe hat den Führerschein bestanden. Die Tochter hat ihren Abschluss gemacht. Geld lose im Umschlag wirkt für so einen Meilenstein nach nichts. Eine Karte v",
    "categories": [
      "bundles",
      "meilensteine"
    ],
    "builder_tags": [
      "bundles",
      "meilensteine",
      "bestanden",
      "geschafft",
      "fuehrerschein"
    ]
  },
  {
    "handle": "wunscherfuller-set-ruhestand-3er-bundle-liegestuhl-segelboot-camping-van-1",
    "title": "Wunscherfüller-Set Ruhestand — 3er Bundle (Liegestuhl · Segelboot · Camping-Van)",
    "motif": "Van)",
    "price": "9.80",
    "category": "ruhestand",
    "category_label": "Ruhestand",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260504_134321_bbd70917-028a-4d8d-8192-c4229beff8e4.png?v=1779625629",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260504_134321_bbd70917-028a-4d8d-8192-c4229beff8e4.png?v=1779625629",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260430_174809_e0ab44d7-32a0-4375-a409-43adaec2c9a5.png?v=1779625630",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260501_101100_76c3ed0f-480a-42ee-a029-71d4383d2b53.png?v=1779625628",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260430_180302_5315a4a1-81fd-4bc7-9e96-3028dfa25c1c.png?v=1779625628"
    ],
    "description": "🎁 Büro-Ruhestand-Komplettset: 3 Designs zum Preis von 2!(9,80 € statt 14,70 €)Im Büro geht jemand in Rente und Sie organisieren das Geschenk. Geld lose im Umschlag wirkt lieblos, eine Karte vom Drogeriemarkt sagt \"schnell unterwegs gekauft\". Mit diesem Bundle haben Sie drei ferti",
    "categories": [
      "bundles",
      "meilensteine"
    ],
    "builder_tags": [
      "bundles",
      "meilensteine",
      "ruhestand"
    ]
  },
  {
    "handle": "wunscherfueller-hochzeit-brautpaare-taube-3er-bundle",
    "title": "Wunscherfüller-Set Hochzeit - Brautpaare & Taube | Kauf 2 bekomme das 3. Gratis",
    "motif": "Brautpaare & Taube | Kauf 2 bekomme das 3. Gratis",
    "price": "9.80",
    "category": "hochzeit",
    "category_label": "Hochzeit",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260526_091036_58bfc2be-93af-43c0-a636-43b648fa25d9.jpg?v=1779789212",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260526_091036_58bfc2be-93af-43c0-a636-43b648fa25d9.jpg?v=1779789212",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260526_091436_73413ae6-df3d-47d1-a703-89d15d348823.jpg?v=1779789213",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260330_181703_1_a5616660-8199-4101-8b04-8a1d48fa078e.jpg?v=1779789216"
    ],
    "description": "🎁 Hochzeit-Set: 3 Designs zum Preis von 2! *(9,80 € statt 14,70 €)*\nIm Mai heiratet deine beste Freundin, im Juli die Kollegin, im September der Cousin und im Oktober die Tochter der Nachbarin. Vier Hochzeiten in einer Saison, und jedes Mal die gleiche Frage: Was schenkt man? Gel",
    "categories": [
      "bundles",
      "hochzeit"
    ],
    "builder_tags": [
      "bundles",
      "hochzeit"
    ]
  },
  {
    "handle": "wunscherfueller-set-geburtstag-hund-katze-blumen",
    "title": "Wunscherfüller-Set Geburtstag · 3er-Bundle (Hund, Katze, Blumen)",
    "motif": "Bundle (Hund, Katze, Blumen)",
    "price": "9.80",
    "category": "geburtstag",
    "category_label": "Geburtstag",
    "is_bundle": true,
    "image": "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_115102_5433c12f-ef90-42b0-86ba-6328f9fdd272.png?v=1779882878",
    "images": [
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_115102_5433c12f-ef90-42b0-86ba-6328f9fdd272.png?v=1779882878",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_114919_711325a8-51de-4160-84f3-1e7ed57d79e5.png?v=1779883777",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_114024_36b07eaf-3c50-4f1c-84b8-e0a6bd8bb998.jpg?v=1779883794",
      "https://cdn.shopify.com/s/files/1/1011/5966/6012/files/hf_20260527_113815_30feed37-9131-4761-ab06-322f321f33b7.png?v=1779883800"
    ],
    "description": "🎁 Geburtstag-Set: 3 Designs zum Preis von 2! *(9,80 € statt 14,70 €)*\nDie Patentochter wird 18, die Schwiegermutter 70 und im Büro hat die Kollegin auch noch Geburtstag. Drei Geburtstage in einem Quartal, und jedes Mal die gleiche Frage: Was schenkt man? Geld ist die ehrliche Ant",
    "categories": [
      "bundles",
      "geburtstag"
    ],
    "builder_tags": [
      "bundles",
      "geburtstag"
    ]
  }
];

window.LENORA_CATEGORIES = {
  "hochzeit": "Hochzeit",
  "christlich": "Christlich",
  "geburtstag": "Geburtstag",
  "lustig": "Lustig",
  "baby": "Baby",
  "meilensteine": "Meilensteine",
  "bundles": "Bundles"
};
